import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CapturedField, ConfigDto, DynamicCard, DynamicField, DynamicLink, FormDataDto, SelfRegImageIdsDto, ServiceSelectionDto } from 'src/app/services/dtos';
import { HttpConfigService } from 'src/app/services/http-config.service';
import { HttpSubmissionService } from 'src/app/services/http-submission.service';
import { ToastService } from 'src/app/services/toast.service';

class ImageToSubmit {
	cardId: number;
	field: DynamicField;
}

@Component({
	selector: 'app-wizard',
	templateUrl: './wizard.component.html',
	styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, OnDestroy {

	config: ConfigDto;
	formData: FormDataDto;
	formDataTextDtos: FormDataDto[];
	formDataImageDtos: FormDataDto[];

	stepIndex = 0;
	infoTitle = "";
	infoSubText = "";

	serviceSelection: ServiceSelectionDto;

	imageCard: DynamicCard;
	loadingMessage: string;
	imageIdList: SelfRegImageIdsDto;

	private langChangeSub: Subscription;
	stepTitle0: string;
	stepSubtext0: string;
	stepTitle1Email: string;
	stepSubtext1Email: string;
	stepTitle1Msisdn: string;
	stepSubtext1Msisdn: string;
	stepTitle2: string;
	stepSubtext2: string;
	stepTitle3: string;
	stepSubtext3: string;
	stepTitle4: string;
	stepSubtext4: string;
	stepTitle5: string;
	stepSubtext5: string;
	savingImageText: string;

	capturedTexts: CapturedField[] = [];
	capturedImages: CapturedField[] = [];

	constructor(
		private toast: ToastService, 
		private httpSubmissionService: HttpSubmissionService, 
		private httpConfigService: HttpConfigService,
		private spinner: NgxSpinnerService,
		private translate: TranslateService) { }

	ngOnInit(): void {

		this.setTranslatedText();

		this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      		this.setTranslatedText();
    	});
	}
	nextStep() {
		this.stepIndex = this.stepIndex + 1;
		this.setInfo();
	}

	previousStep() {
		this.stepIndex = this.stepIndex - 1;
		this.setInfo();

		switch (this.stepIndex) {
			case 2:
				console.log('Text form previous step');
				if (this.capturedTexts.length > 0) {
					console.log('Have captured texts');
					this.formDataTextDtos.forEach(form => {
						form.data.cards.forEach(card => {
							card.fields.forEach(field => {
								console.log('Field:', field);
								var matching = this.capturedTexts.filter(captured => captured.field.id === field.id)[0];
								console.log('matching:', matching);
								if (matching) {
									console.log('set value');
									field.value = matching.field.value;
								}
							});
						});
						// 
					});
				}
				break;
			case 3:
				console.log('Image form previous step');
				if (this.capturedImages.length > 0) {
					console.log('Have captured images');
					this.formDataImageDtos.forEach(form => {
						form.data.cards.forEach(card => {
							card.fields.forEach(field => {
								console.log('Field:', field);
								var matching = this.capturedImages.filter(captured => captured.field.id === field.id)[0];
								console.log('matching:', matching);
								if (matching) {
									console.log('set value');
									field.value = matching.field.value;
								}
							});
						});
						// 
					});
				}
				break;
		}
	}

	setInfo() {
		switch(this.stepIndex) {
			case 0:
				this.infoTitle = this.stepTitle0;
				this.infoSubText = this.stepSubtext0;
				break;
			case 1:
				if (this.serviceSelection.msisdn) {
					this.infoTitle = this.stepTitle1Msisdn;
					this.infoSubText = this.stepSubtext1Msisdn;
				} else {
					this.infoTitle = this.stepTitle1Email;
					this.infoSubText = this.stepSubtext1Email;
				}
				break;
			case 2:
				this.infoTitle = this.stepTitle2;
				this.infoSubText = this.stepSubtext2;
				break;
			case 3:
				this.infoTitle = this.stepTitle3;
				this.infoSubText = this.stepSubtext3;
				break;
			case 4:
				this.infoTitle = this.stepTitle4;
				this.infoSubText = this.stepSubtext4;
				break;
			case 5:
				this.infoTitle = this.stepTitle5;
				this.infoSubText = this.stepSubtext5;
				break;
		}
	}

	saveServiceSelection(event: {'serviceSelection': ServiceSelectionDto }) {
		console.log('Wizard: Passed Service Selection', event.serviceSelection);
		this.serviceSelection = event.serviceSelection;
		this.setTranslatedText();
		this.nextStep();
	}

	saveOtpAndSectionId(event: { 'sectionId': number, 'otp': string, 'axonId': number, 'userRef': string, 'jsonData': string }) {
		console.log('Wizard: Passed OTP Verification. Section ID: ' + event.sectionId + ' - Captured OTP: ' + event.otp);
		this.serviceSelection.sectionId = event.sectionId;
		this.serviceSelection.otp = event.otp;
		this.serviceSelection.axonId = event.axonId;
		if (!this.serviceSelection.idNumber) {
			this.serviceSelection.idNumber = event.userRef;
		}

		this.capturedTexts = [];

		this.spinner.show();
		this.httpSubmissionService.getDynamicFieldConfig(this.serviceSelection)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error', error);
				
				this.toast.show('Invalid OTP');
				throw error;
			})
		)
		.subscribe(
			data => {
				this.spinner.hide();
				if (!data) {
					console.log('Error', data);
					this.toast.show('Error downloading configuration data');
				} else {
					this.formData = {
						id: 0,
						data: data.dynamicLink,
						groupLists: data.groupLists,
						linkedLists: data.linkedLists
					}

					const dynamicLink = data.dynamicLink;
					var json = JSON.parse(event.jsonData);
					let map = new Map<string, string>();
					for (var key in json) {
						map.set(key, json[key])
					}

					this.formDataTextDtos = new Array<FormDataDto>();
					dynamicLink.cards
						.filter(item => item.type === 'text')
						.forEach(card => {

							card.fields.forEach(field => {

								if (field.fieldMapping.columnName === 'customer_id') {
									console.log('Customer ID');
									if (this.serviceSelection.dontHaveId) {
										field.hidden = 1;
										field.mandatory = 0;
										field.value = null;
									} else {
										field.value = this.serviceSelection.idNumber;
										field.editable = 0;
										field.mandatory = 1;
									}

									// if (!this.serviceSelection.name) {
									// 	field.value = this.serviceSelection.idNumber;
									// 	field.editable = 0;
									// 	field.mandatory = 1;
									// } else {
									// 	field.hidden = 1;
									// 	field.mandatory = 0;
									// 	field.value = null;
									// }
								} else if (field.fieldMapping.columnName === 'customer_idtype') {
									console.log('Customer ID Type');
									if (this.serviceSelection.dontHaveId) {
										field.hidden = 1;
										field.mandatory = 0;
										field.value = null;
									} else {
										field.value = this.serviceSelection.idType;
										field.editable = 0;
										field.mandatory = 1;
									}

									// if (!this.serviceSelection.name) {
									// 	field.value = this.serviceSelection.idType;
									// 	field.editable = 0;
									// 	field.mandatory = 1;
									// } else {
									// 	field.hidden = 1;
									// 	field.mandatory = 0;
									// 	field.value = null;
									// }
								} else if (field.fieldMapping.columnName === 'customer_idissue_date') {
									console.log('Customer ID Issue Date');
									if (this.serviceSelection.dontHaveId) {
										field.hidden = 1;
										field.mandatory = 0;
										field.value = null;
									} else {
										field.hidden = 0;
										field.mandatory = 1;
									}

									// if (this.serviceSelection.name) {
									// 	field.hidden = 1;
									// 	field.mandatory = 0;
									// 	field.value = null;
									// } else {
									// 	field.hidden = 0;
									// 	field.mandatory = 1;
									// }
								} else if (field.fieldMapping.columnName === 'customer_idexpiry') {
									console.log('Customer ID Expiry Date');
									if (this.serviceSelection.dontHaveId) {
										field.hidden = 1;
										field.mandatory = 0;
										field.value = null;
									} else {
										field.hidden = 0;
										field.mandatory = 1;
									}

									// if (this.serviceSelection.name) {
									// 	field.hidden = 1;
									// 	field.mandatory = 0;
									// 	field.value = null;
									// } else {
									// 	field.hidden = 0;
									// 	field.mandatory = 1;
									// }
								} else if (field.fieldMapping.columnName === 'customer_full_name') {
									console.log('Customer Full Name');
									if (this.serviceSelection.name && this.serviceSelection.surname) {
										field.value = this.serviceSelection.name + ' ' + this.serviceSelection.surname;
										field.editable = 0;
									}
								} else if (field.fieldMapping.columnName === 'customer_gender') {
									console.log('Customer Gender');
									if (this.serviceSelection.gender) {
										field.value = this.serviceSelection.gender;
										field.editable = 0;
									}
								} else if (field.fieldMapping.columnName === 'customer_birthdate') {
									console.log('Customer Birthdate');
									if (this.serviceSelection.dateOfBirth) {
										field.value = this.serviceSelection.dateOfBirth;
										field.editable = 0;
									}
								} else if (field.fieldMapping.columnName === 'customer_mpla_province') {
									console.log('Customer Province');
									if (this.serviceSelection.province) {
										field.value = this.serviceSelection.province;
									}
								} else if (field.fieldMapping.columnName === 'customer_mpla_municipality') {
									console.log('Customer municipality');
									if (this.serviceSelection.municipality) {
										field.value = this.serviceSelection.municipality;
									}
								} else if (field.fieldMapping.columnName === 'customer_mpla_commune') {
									console.log('Customer commune');
									if (this.serviceSelection.commune) {
										field.value = this.serviceSelection.commune;
									}
								} else if (field.fieldMapping.columnName === 'customer_mpla_cap') {
									console.log('Customer No Cap Son!');
									if (this.serviceSelection.cap) {
										field.value = this.serviceSelection.cap;
									}
								} else if (field.fieldMapping.columnName === 'customer_contact_email') {
									console.log('Customer Contact Email');
									if (this.serviceSelection.email) {
										field.value = this.serviceSelection.email;
										field.editable = 0;
									}
								} else if (field.fieldMapping.columnName === 'customer_contact_number') {
									console.log('Customer Contact Number');
									if (this.serviceSelection.msisdn) {
										field.value = this.serviceSelection.msisdn;
										field.editable = 0;
									}
								}

								map.forEach((value: string, key: string) => {
									if ( field.propertyName === key ) {
										field.value = value;										
									}
								});
							});

							const dynCard: DynamicCard = {
								id: card.id,
								card: card.card,
								type: card.type,
								fields: card.fields
							};

							const dynLink: DynamicLink = {
								sectionId: dynamicLink.sectionId,
								section: dynamicLink.section,
								cards: [dynCard]
							}

							const formDataDto: FormDataDto = {
								id: 0,
								data: dynLink,
								groupLists: data.groupLists,
								linkedLists: data.linkedLists
							};
							this.formDataTextDtos.push(formDataDto);
						});
					
					this.formDataImageDtos = new Array<FormDataDto>();
					dynamicLink.cards
						.filter(item => item.type === 'image')
						.forEach(card => {

							card.fields.forEach(field => {
								if (field.fieldMapping.columnName === 'customer_id_card_front') {
									console.log('Customer ID Front');
									if (this.serviceSelection.name) {
										field.hidden = 1;
										field.mandatory = 0;
									}
								} else if (field.fieldMapping.columnName === 'customer_id_card_back') {
									console.log('Customer ID Back');
									if (this.serviceSelection.name) {
										field.hidden = 1;
										field.mandatory = 0;
									} else if (this.serviceSelection.idType === "Passaporte" || this.serviceSelection.idType === "Passport") {
										field.hidden = 1;
										field.mandatory = 0;
									}
								} 
							});
							this.imageCard = card;
							const dynLink: DynamicLink = {
								sectionId: dynamicLink.sectionId,
								section: dynamicLink.section,
								cards: dynamicLink.cards
							}

							const dynCard: DynamicCard = {
								id: card.id,
								card: card.card,
								type: card.type,
								fields: card.fields
							};

							dynLink.cards = new Array<DynamicCard>(dynCard);

							const formDataDto: FormDataDto = {
								id: 0,
								data: dynLink,
								groupLists: data.groupLists,
								linkedLists: data.linkedLists
							};
							this.formDataImageDtos.push(formDataDto);
						});

					this.nextStep();
				}
			}
		);
	}

	saveTextData(event: {'formData': FormDataDto[] }) {
		console.log('Wizard: Passed Text Form Capture');
		console.log('FormData:', event);
		this.spinner.show();

		this.capturedTexts = [];

		event.formData.forEach(formData => {
			formData.data.cards.forEach(card => {
				card.fields.forEach(field => {
					this.capturedTexts.push({field: {
							id: field.id,
							field: field.field,
							value: field.formControl.value,
							inputField: field.inputField
						}}
					);
				});
			});
		});
		console.log('Captured texts:', this.capturedTexts);

		event.formData.forEach(item => {
			this.httpSubmissionService.saveText(this.serviceSelection, item.data)
			.pipe(
				catchError(error => {
					this.spinner.hide();
					console.log('Error', error);
					
					this.toast.show('Failed submitting data to server: ' + error.error.message);
					throw error;
				})
			)
			.subscribe(
				data => {
					this.spinner.hide();
					if (data.success) {
						this.imageIdList = data.imageIds;
						this.capturedImages = [];
						this.nextStep();
					} else {
						this.toast.show('Error: ' + data.error);
					}
				}
			);
		});
	}	

	saveImageData(event: {'formData': FormDataDto[] }) {
		console.log('Wizard: Passed Image Form Capture');

		if (this.allImagesSubmitted(event.formData)) {
			this.spinner.hide();
			this.nextStep();
		} else {
			this.toast.show('One or more images are missing. Please capture all images');
		}

		// let imagesToSubmit: ImageToSubmit[] = [];

		// event.formData.forEach(formDataDto => {
		// 	formDataDto.data.cards.forEach(card => {
		// 		card.fields.forEach(field => {
		// 			if (!field.submitted) {
		// 				let image: ImageToSubmit = {
		// 					cardId: card.id,
		// 					field: field
		// 				}
		// 				imagesToSubmit.push(image);
		// 			}
		// 		});
		// 	});
		// });

		// console.log('Images to submit:', imagesToSubmit);

		// imagesToSubmit.forEach(image => {
		// 	this.spinner.show();
		// 	this.httpSubmissionService.saveImage(this.serviceSelection, image.cardId, image.field)
		// 		.pipe(
		// 			catchError(error => {
		// 				this.spinner.hide();
		// 				console.log('Error', error);
		// 				image.field.submitted = false;
		// 				this.toast.show('Failed submitting image to server: ' + error.error.message);
		// 				throw error;
		// 			})
		// 		)
		// 		.subscribe(
		// 			data => {	
		// 				image.field.submitted = true;

		// 				if (this.allImagesSubmitted(event.formData)) {
		// 					this.spinner.hide();
		// 					this.packageFormDataDtoAndMoveNext();
		// 				}
		// 			}
		// 		);
		// });		
	}	

	uploadImage(event: {'field': DynamicField }) {
		if (event.field.formControl.value) {
			this.loadingMessage = this.savingImageText;
			this.spinner.show();
			this.httpSubmissionService.saveImage(this.serviceSelection, this.imageCard.id, event.field)
			.pipe(
				catchError(error => {
					this.spinner.hide();
					event.field.submitted = false;
					this.loadingMessage = undefined;
					console.log('Error', error);
					
					this.toast.show('Failed submitting image to server: ' + error.error.message);
					throw error;
				})
			)
			.subscribe(
				data => {	
					this.spinner.hide();
					event.field.submitted = true;
					this.loadingMessage = undefined;

					const exists = this.capturedImages.some(img => img.field.id === event.field.id);
  					if (!exists) {
    					this.capturedImages.push({ field: event.field });
  					}
				}
			);
		}
	}

	private allImagesSubmitted(formData: FormDataDto[]): boolean {
		var allSubmitted = true;
		formData.forEach(formDataDto => {
			formDataDto.data.cards.forEach(card => {
				card.fields.forEach(field => {

					if (field.fieldMapping.columnName === 'customer_id_card_front') {
						if (!this.serviceSelection.name) {
							if (!field.submitted) {
								allSubmitted = false;
							}
						}
					} else if (field.fieldMapping.columnName === 'customer_id_card_back') {
						if (!this.serviceSelection.name) {

							if (this.serviceSelection.idType !== "Passaporte" && this.serviceSelection.idType !== "Passport") {
								if (!field.submitted) {
									allSubmitted = false;
								}
							}
						}
					} else if (!field.submitted) {
						allSubmitted = false;
					}
				});
			});
		});
		return allSubmitted;
	}

	private packageFormDataDtoAndMoveNext() {
		this.formData.data.cards.forEach(card => {
			card.fields.forEach(field => {
				if (card.type === 'text') {
					field.formControl = this.getFormControl(field.id, this.formDataTextDtos);
				} else {
					field.formControl = this.getFormControl(field.id, this.formDataImageDtos);
				}
			});
		});
		this.nextStep();
	}

	private getFormControl(fieldId: number, formDataDtos: FormDataDto[]): FormControl {
		let formControl: FormControl = null;
		formDataDtos.forEach(formDataDto => {
			formDataDto.data.cards.forEach(card => {
				card.fields
					.filter(field => field.id === fieldId)
					.map(field => formControl = field.formControl);
			});
		});
		return formControl;
	}

	private setTranslatedText() {
		this.translate.get('STEP_TITLE_0').subscribe(value => {
			this.stepTitle0 = value;
		});
		this.translate.get('STEP_SUBTEXT_0').subscribe(value => {
			this.stepSubtext0 = value;
		});
		this.translate.get('STEP_TITLE_1_EMAIL').subscribe(value => {
			this.stepTitle1Email = value;
		});
		this.translate.get('STEP_SUBTEXT_1_EMAIL').subscribe(value => {
			this.stepSubtext1Email = value;
			if (this.serviceSelection) {
				console.log('Replacing value');
				this.stepSubtext1Email = this.stepSubtext1Email.replace("[VALUE]", this.serviceSelection.email);
			}
			
		});
		this.translate.get('STEP_TITLE_1_MSISDN').subscribe(value => {
			this.stepTitle1Msisdn = value;
		});
		this.translate.get('STEP_SUBTEXT_1_MSISDN').subscribe(value => {
			this.stepSubtext1Msisdn = value;
			if (this.serviceSelection) {
				this.stepSubtext1Msisdn = this.stepSubtext1Msisdn.replace(/\[VALUE\]/g, this.serviceSelection.msisdn);
			}
		});
		this.translate.get('STEP_TITLE_2').subscribe(value => {
			this.stepTitle2 = value;
		});
		this.translate.get('STEP_SUBTEXT_2').subscribe(value => {
			this.stepSubtext2 = value;
		});
		this.translate.get('STEP_TITLE_3').subscribe(value => {
			this.stepTitle3 = value;
		});
		this.translate.get('STEP_SUBTEXT_3').subscribe(value => {
			this.stepSubtext3 = value;
		});
		this.translate.get('STEP_TITLE_4').subscribe(value => {
			this.stepTitle4 = value;
		});
		this.translate.get('STEP_SUBTEXT_4').subscribe(value => {
			this.stepSubtext4 = value;
		});
		this.translate.get('STEP_TITLE_5').subscribe(value => {
			this.stepTitle5 = value;
		});
		this.translate.get('STEP_SUBTEXT_5').subscribe(value => {
			this.stepSubtext5 = value;
		});
		this.translate.get('SAVING_IMAGE').subscribe(value => {
			this.savingImageText = value;
		});

		this.setInfo();
	}

	ngOnDestroy(): void {
    	this.langChangeSub?.unsubscribe();
  	}
}
